// extracted by mini-css-extract-plugin
export default {"compositeChatLogContainer":"CompositeChatLog_compositeChatLogContainer__0+sa+","chatLoadingContainer":"CompositeChatLog_chatLoadingContainer__pfY0C"};